import React from "react";

const features = [
  "Manage one or multiple locations from a single dashboard",
  "Sync employee data across systems automatically",
  "Streamline communication and operations",
  "Designed for bars, nightclubs, and full-service restaurants",
];

export default function Features() {
  return (
    <section className="bg-gray-100 py-16 px-4">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl font-semibold mb-6">Key Features</h2>
        <ul className="text-left space-y-4 text-lg">
          {features.map((f, i) => (
            <li key={i} className="before:content-['✓'] before:text-green-600 before:mr-2">
              {f}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
